import { defineStore } from 'pinia';
import { getEnvironments } from '@/api/environments';
import type { Environments } from '@/types';

export const useEnvironmentsStore = defineStore('environmentsStore', {
  state: (): Partial<Environments> => ({
    IS_ON_PREMISE: undefined,
    TOTP_AUTH_ENABLED: undefined,
    MAX_ACTIVATED_CONTROLLERS: undefined,
    ON_PREMISE_VERSION: undefined,
    FEATURE_BADGES: undefined,
  }),
  actions: {
    async getEnvironments() {
      const {
        IS_ON_PREMISE,
        ON_PREMISE_VERSION,
        TOTP_AUTH_ENABLED,
        MAX_ACTIVATED_CONTROLLERS,
        FEATURE_BADGES,
      } = await getEnvironments();

      this.IS_ON_PREMISE = IS_ON_PREMISE;
      this.ON_PREMISE_VERSION = ON_PREMISE_VERSION;
      this.TOTP_AUTH_ENABLED = TOTP_AUTH_ENABLED;
      this.MAX_ACTIVATED_CONTROLLERS = MAX_ACTIVATED_CONTROLLERS;
      this.FEATURE_BADGES = FEATURE_BADGES;
    },
  },
});
